import { AffiliatesActionTypes } from "./constants";
import { AffiliatesState } from "./types";
import { AffiliatesActionType } from "./actions";

const INIT_STATE: AffiliatesState = {
  list: [],
  total: 0,
  one: null,
  loading: false,
  error: "",
  affiliateCreateError: "",
  updated: false,
  refreshList: false,
};

const Affiliates = (
  state: AffiliatesState = INIT_STATE,
  action: AffiliatesActionType
): AffiliatesState => {
  switch (action.type) {
    // GET ONE AFFILIATE
    case AffiliatesActionTypes.GET_AFFILIATE:
      return {
        ...state,
        one: null,
        loading: true,
        error: "",
        affiliateCreateError: "",
        updated: false,
      };

    case AffiliatesActionTypes.GET_AFFILIATE_SUCCESS:
      if (action.payload.actionType === AffiliatesActionTypes.GET_AFFILIATE) {
        return {
          ...state,
          loading: false,
          one: action.payload.data,
          error: "",
          affiliateCreateError: "",
          updated: false,
        };
      }
      return state;

    case AffiliatesActionTypes.GET_AFFILIATE_ERROR:
      if (action.payload.actionType === AffiliatesActionTypes.GET_AFFILIATE) {
        return {
          ...state,
          loading: false,
          one: null,
          error: action.payload.error,
          affiliateCreateError: action.payload.error,
          updated: false,
        };
      }
      return state;

    // CREATE AFFILIATE
    case AffiliatesActionTypes.CREATE_AFFILIATE:
      return {
        ...state,
        one: null,
        loading: true,
        error: "",
        affiliateCreateError: "",
      };

    case AffiliatesActionTypes.CREATE_AFFILIATE_SUCCESS:
      if (
        action.payload.actionType === AffiliatesActionTypes.CREATE_AFFILIATE
      ) {
        return {
          ...state,
          loading: false,
          one: action.payload.data,
          error: "",
          affiliateCreateError: "",
        };
      }
      return state;

    case AffiliatesActionTypes.CREATE_AFFILIATE_ERROR:
      if (
        action.payload.actionType === AffiliatesActionTypes.CREATE_AFFILIATE
      ) {
        return {
          ...state,
          loading: false,
          one: null,
          error: action.payload.error,
          affiliateCreateError: action.payload.error,
        };
      }
      return state;

    // UPDATE AFFILIATE
    case AffiliatesActionTypes.UPDATE_AFFILIATE:
      return {
        ...state,
        one: null,
        loading: true,
        error: "",
        affiliateCreateError: "",
      };

    case AffiliatesActionTypes.UPDATE_AFFILIATE_SUCCESS:
      if (
        action.payload.actionType === AffiliatesActionTypes.UPDATE_AFFILIATE
      ) {
        return {
          ...state,
          loading: false,
          one: action.payload.data,
          error: "",
          affiliateCreateError: "",
          updated: true,
        };
      }
      return state;

    case AffiliatesActionTypes.UPDATE_AFFILIATE_ERROR:
      if (
        action.payload.actionType === AffiliatesActionTypes.UPDATE_AFFILIATE
      ) {
        return {
          ...state,
          loading: false,
          one: null,
          error: action.payload.error,
          affiliateCreateError: action.payload.error,
        };
      }
      return state;

    // GET LIST
    case AffiliatesActionTypes.GET_LIST_AFFILIATES:
      return {
        ...state,
        loading: true,
        list: [],
        total: 0,
        one: null,
        error: "",
        affiliateCreateError: "",
        updated: false,
        refreshList: false,
      };

    case AffiliatesActionTypes.GET_LIST_AFFILIATES_SUCCESS:
      if (
        action.payload.actionType === AffiliatesActionTypes.GET_LIST_AFFILIATES
      ) {
        return {
          ...state,
          list: action.payload.data.items,
          loading: false,
          total: action.payload.data.total,
          one: null,
          error: "",
          affiliateCreateError: "",
          updated: false,
          refreshList: false,
        };
      }
      return state;

    case AffiliatesActionTypes.GET_LIST_AFFILIATES_ERROR:
      if (
        action.payload.actionType === AffiliatesActionTypes.GET_LIST_AFFILIATES
      ) {
        return {
          ...state,
          error: action.payload.error,
          list: [],
          total: 0,
          loading: false,
          updated: false,
          refreshList: false,
        };
      }
      return state;

    // DELETE AFFILIATE
    case AffiliatesActionTypes.DELETE_AFFILIATE:
      return {
        ...state,
        refreshList: false,
      };

    case AffiliatesActionTypes.DELETE_AFFILIATE_SUCCESS:
      if (
        action.payload.actionType === AffiliatesActionTypes.DELETE_AFFILIATE
      ) {
        return {
          ...state,
          refreshList: true,
        };
      }
      return state;

    case AffiliatesActionTypes.DELETE_AFFILIATE_ERROR:
      if (
        action.payload.actionType === AffiliatesActionTypes.DELETE_AFFILIATE
      ) {
        return {
          ...state,
          error: action.payload.error,
          refreshList: false,
        };
      }
      return state;

    default:
      return state;
  }
};

export default Affiliates;
